import { useState } from 'react'
import { Button } from '@/components/ui/button'
import { toast } from '@/lib/toast'
import { listDuplicates, type DuplicatePairs } from './api'
import { DuplicatesDialog } from './DuplicatesDialog'

/**
 * The entry to the duplicate finder above the organisations. Finding pairs compares every
 * organisation with every other, so it runs only when asked ("Dubbelen bekijken"), never on
 * page load.
 */
export function DuplicatesBanner({ onMerged }: { onMerged?: () => void }) {
  const [pairs, setPairs] = useState<DuplicatePairs | null>(null)
  const [open, setOpen] = useState(false)
  const [busy, setBusy] = useState(false)

  async function look() {
    setBusy(true)
    try {
      const answer = await listDuplicates()
      if (answer.items.length === 0) {
        toast.success('Geen mogelijke dubbelen gevonden')
        return
      }
      setPairs(answer)
      setOpen(true)
    } catch (caught) {
      toast.error(caught instanceof Error ? caught.message : 'Dubbelen zoeken mislukt.')
    } finally {
      setBusy(false)
    }
  }

  return (
    <div aria-live="polite">
      <Button type="button" variant="outline" size="sm" disabled={busy} onClick={() => void look()}>
        {busy ? 'Zoeken…' : 'Dubbelen bekijken'}
      </Button>
      {pairs && open ? (
        <DuplicatesDialog
          open={open}
          onOpenChange={setOpen}
          pairs={pairs}
          onChange={setPairs}
          onMerged={onMerged}
        />
      ) : null}
    </div>
  )
}
